import apiClient from '@/lib/apiClient';
import type { AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { handleMockRequest } from './mockHandlers';

// Enable by setting VITE_ENABLE_MOCKS=true in .env.development only
const enableMocks = import.meta.env.VITE_ENABLE_MOCKS === 'true';

export function installAxiosMocks() {
  if (!enableMocks) return;

  // Short-circuit adapter by intercepting requests early
  apiClient.interceptors.request.use(async(config: InternalAxiosRequestConfig) => {
    // Attach a marker to identify mockable requests
    (config as any).__mockCandidate = true;
    return config;
  });

  apiClient.interceptors.response.use(
    (response) => response,
    async(error) => {
      const config = error.config as InternalAxiosRequestConfig & { __mockCandidate?: boolean };
      if (!config || !config.__mockCandidate) throw error;

      const mocked: AxiosResponse | null = await handleMockRequest(config);
      if (mocked) return Promise.resolve(mocked);
      // If not handled by mock, bubble original error
      throw error;
    },
  );
}

export default installAxiosMocks;

